<template>
  <div
    class="reduced-price-formula h7-text black--text text-start"
    data-qa="reduced-price-formula">
    <ShowFormula
      v-if="formula"
      :formula-string="formula"
      :use-space="true"/>
    <span v-else>
      {{ $t('Tenders.StandardFormula') }}
    </span>
    <StandartReducedPrice
      v-if="!formula && standart_vars.length"
      class="my-2"
      dense
      :variables="standart_vars.map(el => el.formulaCode)"/>
    <CriteriaCardVars
      :card="card"
      class="mt-3"/>
  </div>
</template>
<script>
import ShowFormula from 'components/common/ShowFormula.vue'
import CriteriaCardVars from 'components/tenders/critetia/CriteriaCardVars.vue'
import StandartReducedPrice from 'components/tenders/critetia/StandartReducedPrice.vue'

export default {
  name: 'reducedPriceFormula',
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    formula() {
      return this.card.formula || this.card.reducedPriceFormula
    },
    standart_vars() {
      if ( this.card?.reducedPriceCriterias ) {
        return this.card?.reducedPriceCriterias?.filter(el => el.formulaCode)
      } else if ( this.card?.criterias ) {
        return this.card?.criterias?.filter(el => el.useInRedFormula)
      }
      return []
    }
  },
  components: {
    ShowFormula,
    CriteriaCardVars,
    StandartReducedPrice
  }
}
</script>
<style lang="scss" scoped>
.reduced-price-formula {
  .formula {
    border-bottom: 1px solid var(--v-main__green-base);
  }
}
</style>
